import {QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';
import {ItemDataFieldModel} from './itemData';
import {SelectOptionsType} from 'global';

export interface BoardFormModel {
    id: string; // Guid equivalent in TypeScript is string
    title: string;
    formFieldsData: ItemDataFieldModel[];
    boardId: string; // Guid equivalent in TypeScript is string
    isDefault: boolean;
    summaryViews: Array<BoardFormSummaryViewsOwned>;
}
export interface BoardFromListingRequestFilters {
    board: {
        slug: string;
    };
    boardId: string;
}
export interface BoardFormListingRequest
    extends QueryBaseTypeWithCursorPaginationWhereAndOrder<BoardFromListingRequestFilters> {}
export interface BoardFormResponse extends Omit<BoardFormModel, 'FormFields'> {
    FormFields: Array<ItemDataFieldModel>;
}
export interface BoardFormGenerateRequest {
    SelectedStatus: SelectOptionsType;
    SelectedForm: SelectOptionsType;
    SelectedSprint: SelectOptionsType;
}
export const defaultBoardForm: BoardFormGenerateRequest = {
    SelectedStatus: {label: '', value: ''},
    SelectedForm: {label: '', value: ''},
    SelectedSprint: {label: '', value: ''},
};

export interface BoardFormSummaryViewsOwned {
    value: string;
    uniqueId: string;
}
